<template>
  <ClientFilter :id="id" v-model="modelValue.ownerNaturalIds" />
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';

import { OrderSearchCriteria } from '@/model';

import ClientFilter from '@/components/search/ClientFilter.vue';

const modelValue = defineModel({
  type: OrderSearchCriteria,
  default: () => new OrderSearchCriteria(),
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});

const { id } = toRefs(props);
</script>
